import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import {
  ConfigService,
  EntityService,
  TokenService,
  Utils
} from 'viggo-sistemas-core-web';
import { ILinhaProducao } from '../models/linha_producao.model';

export interface IContagem {
  id: string;
  descricao: string;
  quantidade: number;
}
interface IResultContagem {
  id: string;
  contagem: IContagem[];
}
export interface IContagemProcessos {
  id: string;
  descricao: string;
  count: number;
  gerencia_partes: boolean;
}
interface IResultContagemProcessos {
  id: string;
  processos_count: IContagemProcessos[];
}

@Injectable()
export class LinhaProducaoService extends EntityService<ILinhaProducao> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      baseEntityEndPoint: 'linha_producao',
      urlBackend: configService.backendURL
    });
  }

  /**
   * Contagem de etapas
   * @param linha_producao_id
   * @param tipo
   * @returns
   */
  getContagem(where: any): Observable<{ linha_producao: IResultContagem }> {
    const url = `${this.baseURL}/${where.linha_producao_id}/get_contagem`;
    let params = new HttpParams();
    const headers = this.getHeader();
    params = params.append('domain_id', this.tokenService.getDomain().id);
    where['etapa_id'] = undefined; // PARA EVITAR QUE ZERE O COUNT NAS ETAPAS Q N ESTÃO SELECIONADAS
    return this.http.post<{ linha_producao: IResultContagem }>(
      url,
      this.managementStatus(
        Utils.flattenObject({ where: { ...where } }, '', false, [
          'ate_filter',
          'de_filter',
          'attributes_filter',
          'domain_id',
          'modelo.linha_producao_id',
          'linha_producao_id'
        ])
      ),
      {
        headers
      }
    );
  }

  managementStatus(body) {
    if (!Array.isArray(body['status']) && typeof body['status'] === 'string')
      body['status'] = body['status'].split(',');
    if (
      !Array.isArray(body['processo.status']) &&
      typeof body['processo.status'] === 'string'
    )
      body['processo.status'] = body['processo.status'].split(',');
    if (
      !Array.isArray(body['pedido_parte.status']) &&
      typeof body['pedido_parte.status'] === 'string'
    )
      body['pedido_parte.status'] = body['pedido_parte.status'].split(',');
    if (
      !Array.isArray(body['status_entrega']) &&
      typeof body['status_entrega'] === 'string'
    )
      body['status_entrega'] = body['status_entrega'].split(',');
    if (
      !Array.isArray(body['status_entrega_peca']) &&
      typeof body['status_entrega_peca'] === 'string'
    )
      body['status_entrega_peca'] = body['status_entrega_peca'].split(',');
    if (Array.isArray(body['linha_producao_id']))
      body['linha_producao_id'] = body['linha_producao_id'][0];
    if (Array.isArray(body['modelo.linha_producao_id']))
      body['modelo.linha_producao_id'] = body['modelo.linha_producao_id'][0];
    if (Array.isArray(body['etapa_id'])) body['etapa_id'] = body['etapa_id'][0];
    if (Array.isArray(body['processo_id']))
      body['processo_id'] = body['processo_id'][0];
    return body;
  }

  /**
   * Contagem de processos
   * @param linha_producao_id
   * @param tipo
   * @returns
   */
  getContagemProcessos(
    linha_producao_id: string,
    tipo: string
  ): Observable<{ linha_producao: IResultContagemProcessos }> {
    const url = `${this.baseURL}/${linha_producao_id}/processos_count`;
    let params = new HttpParams();
    const headers = this.getHeader();
    params = params.append('domain_id', this.tokenService.getDomain().id);
    if (tipo === 'gerenciamento') {
      params = params.append('gerencia_partes', true);
      params = params.append('filtra_processos', true);
    }
    return this.http.get<{ linha_producao: IResultContagemProcessos }>(url, {
      headers,
      params
    });
  }
}
